<script setup lang="ts">
const emit = defineEmits(["close"]);
</script>
<template>
  <BaseLayoutModal width="medium" @close="$emit('close')">
    <template #header> <slot name="header" /> </template>
    <template #content>
      <slot name="content" />
      <div class="mt-6 flex">
        <BaseButtonSubmit
          :text="$t('main.modalPropertyList.close')"
          data-test="button-close-modal-cancel-mint-success"
          size="long"
          class="mx-auto"
          @click="$emit('close')"
        />
      </div>
    </template>
  </BaseLayoutModal>
</template>
